import { render, staticRenderFns } from "./ExtraItems.vue?vue&type=template&id=0479a3b0&scoped=true&lang=pug&"
import script from "./ExtraItems.vue?vue&type=script&lang=js&"
export * from "./ExtraItems.vue?vue&type=script&lang=js&"
import style0 from "./ExtraItems.vue?vue&type=style&index=0&id=0479a3b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0479a3b0",
  null
  
)

export default component.exports